import PortalFormModal from './PortalFormModal';
import React, { useState } from 'react';
import { MdEdit } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import Attention from '../../ReusableComponents/Attention';
import StatusBadge from '../../ReusableComponents/StatusBadge';
import { usePortal, usePortalSettings, useSavePortalSettings } from '../hooks';
import { Loading, ErrorNotice, Success } from './Feedback';
export default function PortalConfiguration({ organizationId }) {
  const { user } = usePortal();
  if (user?.role !== 'region_admin') return null;
  return <RegionalPortalConfiguration organizationId={organizationId} />;
}
function RegionalPortalConfiguration({ organizationId }) {
  const query = usePortalSettings(organizationId),
    save = useSavePortalSettings(organizationId),
    [editing, setEditing] = useState(false),
    [apiUrl, setApiUrl] = useState('');
  const settings = query.data,
    canEdit = settings?.can_edit && save.allowed;
  const needsSecret = !settings?.has_shared_secret && !!apiUrl;
  return (
    <section className="card module-card module-content hidethis">
      <div className="card-body">
        <div className="portal-admin-row">
          <div className="module-content-heading">
            <h2>Conexão com o portal</h2>
            <p>Endereços do portal de inscrições e chave de comunicação desta organizadora.</p>
          </div>
          {canEdit && (
            <DefaultButton
              text="Editar conexão"
              bg="info"
              icon={<MdEdit />}
              onClick={() => {
                setApiUrl(settings.portal_api_url || '');
                save.reset();
                setEditing(true);
              }}
            />
          )}
        </div>
        <ErrorNotice error={query.error} />
        <Success show={save.isSuccess}>Conexão atualizada.</Success>
        {query.isLoading ? (
          <Loading />
        ) : (
          settings && (
            <>
              <dl className="portal-admin-facts">
                <div>
                  <dt>API do portal</dt>
                  <dd>{settings.portal_api_url || 'Não configurada'}</dd>
                </div>
                <div>
                  <dt>Acesso ao portal</dt>
                  <dd>{settings.portal_frontend_url || 'Não configurado'}</dd>
                </div>
                <div>
                  <dt>Chave de comunicação</dt>
                  <dd>
                    <StatusBadge variant={settings.has_shared_secret ? 'success' : 'secondary'}>
                      {settings.has_shared_secret ? 'Cadastrada' : 'Não cadastrada'}
                    </StatusBadge>
                  </dd>
                </div>
              </dl>
              {editing && (
                <PortalFormModal
                  title="Conexão com o portal"
                  description="Endereços e credenciais desta organizadora."
                  busy={save.isLoading}
                  allowed={canEdit}
                  error={save.error}
                  onClose={() => {
                    save.reset();
                    setEditing(false);
                  }}
                  onSubmit={(e) => {
                    e.preventDefault();
                    save.mutate(Object.fromEntries(new FormData(e.currentTarget)), {
                      onSuccess: () => setEditing(false),
                    });
                  }}
                  submitText="Salvar conexão"
                >
                  <div className="portal-admin-grid">
                    <label className="form-label">
                      <span>
                        URL da API do portal <small className="text-muted">(opcional)</small>
                      </span>
                      <input
                        name="portal_api_url"
                        className="form-control"
                        type="url"
                        maxLength={2048}
                        placeholder="https://api-portal.suaorganizacao.com.br"
                        value={apiUrl}
                        onChange={(e) => setApiUrl(e.target.value)}
                      />
                    </label>
                    <label className="form-label">
                      <span>
                        URL de acesso ao portal <small className="text-muted">(opcional)</small>
                      </span>
                      <input
                        name="portal_frontend_url"
                        className="form-control"
                        type="url"
                        maxLength={2048}
                        placeholder="https://portal.suaorganizacao.com.br"
                        defaultValue={settings.portal_frontend_url || ''}
                      />
                    </label>
                  </div>

                  <label className="form-label">
                    <span>
                      {settings.has_shared_secret
                        ? 'Nova chave de comunicação'
                        : 'Chave de comunicação'}{' '}
                      {needsSecret ? (
                        <Attention />
                      ) : (
                        <small className="text-muted">(opcional)</small>
                      )}
                    </span>
                    <input
                      name="portal_shared_secret"
                      className="form-control"
                      type="password"
                      autoComplete="new-password"
                      minLength={32}
                      maxLength={4096}
                      required={needsSecret}
                      placeholder={
                        settings.has_shared_secret
                          ? 'Deixe em branco para manter a chave atual'
                          : 'Pelo menos 32 caracteres'
                      }
                    />
                    <small className="form-text">
                      {settings.has_shared_secret
                        ? 'A chave atual será preservada se este campo ficar em branco.'
                        : 'Obrigatória ao informar a URL da API. Use a chave fornecida na configuração do portal.'}
                    </small>
                  </label>
                </PortalFormModal>
              )}
            </>
          )
        )}
      </div>
    </section>
  );
}
